/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSoMe from 'base/components/standalone/SoMe';

export const DynamicStandaloneSoMe = StandaloneSoMe;
export type DynamicStandaloneSoMeProps = PropsFromComponent<typeof StandaloneSoMe>;

export const DynamicStandaloneSoMeWith = (extras: DynamicStandaloneExtras): typeof StandaloneSoMe => {
    return function DynamicStandaloneSoMe(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SoMe');
        return <StandaloneSoMe {...mergeProps({ options: { theme } }, props)} />;
    }
}